import { render } from "./consumptionDetails.vue?vue&type=template&id=30a1a224&scoped=true"
import script from "./consumptionDetails.vue?vue&type=script&lang=js"
export * from "./consumptionDetails.vue?vue&type=script&lang=js"

import "./consumptionDetails.vue?vue&type=style&index=0&id=30a1a224&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-30a1a224"

export default script